// Accès à vie (paiement unique par Stripe Checkout) : docs/produit/lifetime/cadrage-2026-10-11.md, § 3.3 et 3.5

// Valeur du choix « Accès à vie » dans Subscribe.vue (les choix mensuel et annuel portent l'identifiant du prix Stripe)
export const LIFETIME_CHOICE = 'lifetime';

// Adresse proposée sur la page de retour si l'activation n'aboutit pas
export const SUPPORT_EMAIL = 'bonjour@odysound.com';

// Le pays du compte est un texte libre : « US », « U.S.A. », « United States », « États-Unis », « Austin, USA »…
export function isUnitedStates (country) {
  if (typeof country !== 'string') return false;
  let text = country.normalize ? country.normalize('NFD') : country;
  text = text.replace(/[̀-ͯ]/g, '').replace(/\./g, '').toLowerCase();
  const words = text.split(/[^a-z]+/);
  const compact = words.join('');
  return words.indexOf('us') !== -1 || words.indexOf('usa') !== -1 ||
    /^(us|usa|america|amerique)$/.test(compact) || /unitedstates|etatsunis/.test(compact);
}

// Devise de l'accès à vie : dollars si le navigateur est en anglais américain ou si le compte est aux États-Unis,
// euros sinon (l'API choisit le prix Stripe correspondant, 299 € ou 299 $)
export function lifetimeCurrency (user) {
  const language = (window.navigator.language || '').toLowerCase();
  if (language === 'en-us') return 'usd';
  if (user && isUnitedStates(user.country)) return 'usd';
  return 'eur';
}

// Stripe ramène le client sur l'adresse du tableau de bord connue de l'API (front_domain, en français). On retient la
// langue du client avant de l'envoyer chez Stripe pour le remettre dans sa langue à son retour (paiement ou abandon).
const CHECKOUT_LOCALE_KEY = 'lifetime-checkout-locale';
const CHECKOUT_LOCALE_MAX_AGE = 3 * 3600 * 1000;

export function rememberCheckoutLocale (locale) {
  try {
    window.localStorage.setItem(CHECKOUT_LOCALE_KEY, JSON.stringify({ locale: locale, at: Date.now() }));
  } catch (e) {}
}

// À appeler à l'arrivée sur une page de retour de Stripe. Renvoie true si la page est rechargée dans la langue retenue
// (l'appelant s'arrête alors là). `hash` : la route à rouvrir, par défaut celle de la page courante.
export function restoreCheckoutLocale (hash) {
  let saved = null;
  try {
    saved = JSON.parse(window.localStorage.getItem(CHECKOUT_LOCALE_KEY));
    window.localStorage.removeItem(CHECKOUT_LOCALE_KEY);
  } catch (e) {}
  if (!saved || typeof saved.locale !== 'string' || !/^[a-z]{2}$/.test(saved.locale)) return false;
  if (saved.locale === window.CURRENT_LOCALE || !(Date.now() - saved.at < CHECKOUT_LOCALE_MAX_AGE)) return false;

  // Lien de changement de langue de l'en-tête Kirby : il pointe vers la même page dans l'autre langue
  const link = document.querySelector('a[hreflang="' + saved.locale + '"]');
  if (!link || !link.href) return false;
  window.location.replace(link.href.split('#')[0] + (hash || window.location.hash));
  return true;
}
